import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/IT-support.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Our solutions are Reliable"
				breadcrumbText="support"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}